import React from 'react'

const DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const slotLabel = (iso) => {
  const d = new Date(iso)
  if (!Number.isFinite(d.getTime())) return null
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  return `${DAY[d.getDay()]}, ${MONTH[d.getMonth()]} ${d.getDate()} at ${time}`
}

export default function DoneStep ({ step, phase, testMode }) {
  const isFollowup = phase === 'followup'
  // Confirm the slot they actually chose rather than restating the window — this is
  // the last screen they see, and it's what they'll remember the appointment by.
  const slot = step?.bookingAt ? slotLabel(step.bookingAt) : null

  return (
    <div className="study-card study-done">
      <div className="study-done__check">✓</div>
      <h2 className="study-h2">{isFollowup ? 'Follow-up complete' : 'Main session complete'}</h2>

      {isFollowup
        ? <p>Thank you — that completes the study. Your bonus is paid on completion.</p>
        : slot
          ? <>
              <p>Thank you. Your 20-minute follow-up is booked for:</p>
              <p className="study-done__slot">{slot}</p>
              <p>You’ll get a reminder with your personal link — it’s the same link you used today.</p>
            </>
          : <p>Thank you. Your follow-up is booked for day 6–8; you’ll return then for the final 20 minutes.</p>}

      {!isFollowup && testMode && (
        <p className="study-hint">Test mode: use the admin bar’s “open follow-up” then visit <code>/study/followup</code>.</p>
      )}
    </div>
  )
}
